// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton_dashboardlayout {
    display: flex;
    max-width: 100%;
    height: 100vh;
    background-color: var(--bg);
}

.skeleton_dashboardlayout_content {
    overflow-y: auto;
    width: 100%;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.skeleton_dashboardlayout_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 4px 0 16px;
    position: relative;
    border-bottom: 1px solid var(--border-light);
}

.skeleton_dashboardlayout_traduction_text {
    width: 60px;
    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);
    background-size: 200% 100%;
    animation: shimmer 1.5s ease-in-out infinite;
    height: 6px;
    margin: 7px 0;
    border-radius: 3px;
}

.skeleton_dashboardlayout_title {
    width: 80px;
    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);
    background-size: 200% 100%;
    animation: shimmer 1.5s ease-in-out infinite;
    height: 6px;
    border-radius: 3px;
}

.skeleton_dashboardlayout_traduction {
    background-color: var(--bg-card);
    padding: 8px 16px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--border);
    font-size: 12px;
}

.skeleton_dashboardlayout_traduction img {
    height: 8px;
    width: 8px;
    opacity: 0.4;
}

.skeleton_dashboardlayout_grid {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 20px;
    width: 100%;
    height: 100%;
}

.skeleton_dashboardlayout_griditem {
    height: 100%;
    border-radius: var(--radius-md);
    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);
    background-size: 200% 100%;
    animation: shimmer 1.5s ease-in-out infinite;
    border: 1px solid var(--border);
}

.skeleton_dashboardlayout_griditem_1 {
    grid-column: 1 / 5;
}

.skeleton_dashboardlayout_griditem_2 {
    grid-column: 5 / 11;
}

.skeleton_dashboardlayout_griditem_3 {
    grid-column: 1 / 6;
}

.skeleton_dashboardlayout_griditem_4 {
    grid-column: 6 / 11;
}

/* Page loader spinner */
.lds-ripple {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
}

.lds-ripple div {
    position: absolute;
    border: 3px solid var(--primary);
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1.2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
}

@keyframes lds-ripple {
    0% {
        top: 28px;
        left: 28px;
        width: 0;
        height: 0;
        opacity: 0;
    }
    4.9% {
        top: 28px;
        left: 28px;
        width: 0;
        height: 0;
        opacity: 0;
    }
    5% {
        top: 28px;
        left: 28px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: 0px;
        left: 0px;
        width: 56px;
        height: 56px;
        opacity: 0;
    }
}

.pageLoaderBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/pageLoader/pageLoader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,uGAAuG;IACvG,0BAA0B;IAC1B,4CAA4C;IAC5C,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uGAAuG;IACvG,0BAA0B;IAC1B,4CAA4C;IAC5C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,uGAAuG;IACvG,0BAA0B;IAC1B,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;IACA;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;IACA;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;QACT,UAAU;IACd;IACA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".skeleton_dashboardlayout {\n    display: flex;\n    max-width: 100%;\n    height: 100vh;\n    background-color: var(--bg);\n}\n\n.skeleton_dashboardlayout_content {\n    overflow-y: auto;\n    width: 100%;\n    padding: 24px 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.skeleton_dashboardlayout_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 100%;\n    padding: 4px 0 16px;\n    position: relative;\n    border-bottom: 1px solid var(--border-light);\n}\n\n.skeleton_dashboardlayout_traduction_text {\n    width: 60px;\n    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s ease-in-out infinite;\n    height: 6px;\n    margin: 7px 0;\n    border-radius: 3px;\n}\n\n.skeleton_dashboardlayout_title {\n    width: 80px;\n    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s ease-in-out infinite;\n    height: 6px;\n    border-radius: 3px;\n}\n\n.skeleton_dashboardlayout_traduction {\n    background-color: var(--bg-card);\n    padding: 8px 16px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid var(--border);\n    font-size: 12px;\n}\n\n.skeleton_dashboardlayout_traduction img {\n    height: 8px;\n    width: 8px;\n    opacity: 0.4;\n}\n\n.skeleton_dashboardlayout_grid {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: 20px;\n    width: 100%;\n    height: 100%;\n}\n\n.skeleton_dashboardlayout_griditem {\n    height: 100%;\n    border-radius: var(--radius-md);\n    background: linear-gradient(90deg, var(--border-light) 0%, var(--border) 50%, var(--border-light) 100%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s ease-in-out infinite;\n    border: 1px solid var(--border);\n}\n\n.skeleton_dashboardlayout_griditem_1 {\n    grid-column: 1 / 5;\n}\n\n.skeleton_dashboardlayout_griditem_2 {\n    grid-column: 5 / 11;\n}\n\n.skeleton_dashboardlayout_griditem_3 {\n    grid-column: 1 / 6;\n}\n\n.skeleton_dashboardlayout_griditem_4 {\n    grid-column: 6 / 11;\n}\n\n/* Page loader spinner */\n.lds-ripple {\n    display: inline-block;\n    position: relative;\n    width: 64px;\n    height: 64px;\n}\n\n.lds-ripple div {\n    position: absolute;\n    border: 3px solid var(--primary);\n    opacity: 1;\n    border-radius: 50%;\n    animation: lds-ripple 1.2s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n\n.lds-ripple div:nth-child(2) {\n    animation-delay: -0.5s;\n}\n\n@keyframes lds-ripple {\n    0% {\n        top: 28px;\n        left: 28px;\n        width: 0;\n        height: 0;\n        opacity: 0;\n    }\n    4.9% {\n        top: 28px;\n        left: 28px;\n        width: 0;\n        height: 0;\n        opacity: 0;\n    }\n    5% {\n        top: 28px;\n        left: 28px;\n        width: 0;\n        height: 0;\n        opacity: 1;\n    }\n    100% {\n        top: 0px;\n        left: 0px;\n        width: 56px;\n        height: 56px;\n        opacity: 0;\n    }\n}\n\n.pageLoaderBox {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
